import { render, staticRenderFns } from "./PageTop.vue?vue&type=template&id=2334ad35&scoped=true&"
import script from "./PageTop.vue?vue&type=script&lang=js&"
export * from "./PageTop.vue?vue&type=script&lang=js&"
import style0 from "./PageTop.vue?vue&type=style&index=0&id=2334ad35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2334ad35",
  null
  
)

export default component.exports